import { Component, Input } from '@angular/core';
import { KeyValue } from '@app/services/webform.service';
import { formatNumber } from '@app/helpers/webform';

@Component({
  standalone: false,
  selector: 'webform-calc-mortgage',
  templateUrl: './mortgage.component.html',
  styleUrl: './mortgage.component.scss',
})
export class MortgageComponent {
  @Input() result!: KeyValue;
  @Input() formId!: string;
  @Input() formData!: KeyValue;
  formatNumber: Function = formatNumber;

  public get contractEnd(): string {
    return '';
  }
}
